import { Injectable } from '@angular/core';
import { SideNavSchema } from 'src/app/shared/models/navigation.model';
import { mainSideNavSchema } from '../schemas/navigation-schema';
import { AppStateService } from '../services/app-state.service';
import { StaffPermissionsService } from '../services/staff-permissions.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private sideNavSchemaSource$ = new BehaviorSubject<SideNavSchema>(mainSideNavSchema);

  public sideNavSchema$ = combineLatest([
    this.sideNavSchemaSource$,
    this.appStateService.isPatientAppActive$,
    this.staffPermissionsService.permissions$
  ]).pipe(
    map(([schema, isPatientAppActive, permissions]) => {
      if (!schema) return schema;
      return {
        ...schema,
        groups: schema.groups.map(group => ({
          ...group,
          actions: group.actions.filter(action => {
            if (action.requiresPatientApp && !isPatientAppActive) {
              return false;
            }
            if (action.requiredPermission && !permissions[action.requiredPermission]) {
              return false;
            }
            return true;
          })
        }))
      };
    })
  );

  public get sideNavSchema(): SideNavSchema {
    return this.sideNavSchemaSource$.value;
  }

  public sideNavExpanded = false;
  public sidebarHidden = false;

  constructor(
    private appStateService: AppStateService,
    private staffPermissionsService: StaffPermissionsService
  ) {}

  updateSideNavSchema(newSchema: SideNavSchema) {
    this.sideNavSchemaSource$.next(newSchema);
  }
}
